import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f1c8bd38"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c8bd38')) {
      api.createRecord('f1c8bd38', component.options)
    } else {
      api.reload('f1c8bd38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f1c8bd38", function () {
      api.rerender('f1c8bd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/echarts/chart/bar/stack/IkBarStackChart/index.vue"
export default component.exports